import * as ReactRedux from 'react-redux';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import PosSaleComponent from './PosSaleComponent';
import { AppState } from '../app/app.types';
import {
  registerPos,
  getPredefinedItems,
  createPredefinedItem,
  updatePredefinedItem,
  deletePredefinedItem
} from './Actions';
import { PosRegisterRequest } from './Types';
import { getMembers } from '../members/members.actions';
import { getPayers, getPayMethods } from 'src/billing/billing.actions';

const mapDispatchToProps = (dispatch) => {
  return {
    registerPos: (posRegisterRequest: PosRegisterRequest) => dispatch(registerPos(posRegisterRequest)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    getMembers: () => dispatch(getMembers()),
    getPayers: () => dispatch(getPayers()),
    getPayMethods: (payerId: number) => dispatch(getPayMethods(payerId)),
    toPosSaleResult: () => dispatch(push(paths.posSaleResult)),
    getPredefinedItems: () => dispatch(getPredefinedItems()),
    createPredefinedItem: (req: PosRegisterRequest) => dispatch(createPredefinedItem(req)),
    updatePredefinedItem: (req: PosRegisterRequest) => dispatch(updatePredefinedItem(req)),
    deletePredefinedItem: (id: number) => dispatch(deletePredefinedItem(id))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    posState: state.posState,
    businessState: state.businessState,
    membersState: state.membersState,
    payersState: state.payersState,
    payMethodsState: state.payMethodsState
  };
};

const PosSale = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PosSaleComponent);

export default PosSale;


// WEBPACK FOOTER //
// ./src/pos/PosSale.tsx